<template>
  <section class="news-container">
    <div class="header">
      <el-tabs v-model="activeTab">
        <el-tab-pane
          v-for="(tab, index) in tabList"
          :key="index"
          :label="tab.label"
          :name="String(tab.name)"
        ></el-tab-pane>
      </el-tabs>
      <div class="btn">
        <v-button
          v-if="activeTab === 'Posts'"
          type="primary"
          @click="routerToPostDetail">New Post</v-button>
        <v-button
          v-else-if="activeTab === 'Categories'"
          type="primary"
          @click="handlerNewCategory">New Category</v-button>
        <v-button
          v-else-if="activeTab === 'Tags'"
          type="primary"
          @click="handlerNewTag">New Tag</v-button>
      </div>
    </div>

    <div class="content-container">
      <section v-show="activeTab === 'Posts'">
        <div class="filter-container">
          <div class="filter-list">
            <v-select
              v-model="postForm.status"
              placeholder="All Posts"
              :list="statusList"
              @change="filterArticles" />
            <v-select
              v-model="postForm.category_id"
              placeholder="All Categories"
              :list="categoryList"
              @change="filterArticles" />
            <v-select
              v-model="postForm.newest"
              placeholder="Newest First"
              :list="newestList"
              @change="filterArticles" />
          </div>
          <!-- <div>
            <v-button
              type="primary"
              @click="routerToPostDetail">New Post</v-button>
          </div> -->
        </div>
        <div class="transparent">
          <el-table
            :data="articlesData"
            stripe
            style="width: 100%"
            @row-click="routerToArticle">
            <el-table-column
              label="Title (English)">
              <template slot-scope="scope">
                <span>
                  {{ scope.row.titleData['en-US'] }}
                </span>
              </template>
            </el-table-column>
            <el-table-column
              label="Title (Chinese)">
              <template slot-scope="scope">
                <span>
                  {{ scope.row.titleData['zh-HK'] }}
                </span>
              </template>
            </el-table-column>
            <el-table-column
              label="Category">
              <template slot-scope="scope">
                {{ getOptionName('categoryList', scope.row.category_id) }}
              </template>
            </el-table-column>
            <el-table-column
              label="Status">
              <template slot-scope="scope">
                <span
                  v-if="scope.row.status === 0"
                  class="span-checkbox warning">Draft</span>
                <span
                  v-if="scope.row.status === 2"
                  class="span-checkbox">Scheduled</span>
                <span
                  v-if="scope.row.status === 1"
                  class="span-checkbox success">Published</span>
                <span
                  v-if="scope.row.status === 3"
                  class="span-checkbox info">Unpublished</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="publish_at"
              label="Published"></el-table-column>
            <el-table-column
              prop="updated_at"
              label="Updated"></el-table-column>
          </el-table>

        </div>
        <v-pagination
          :total="pageConfig.total"
          :current="pageConfig.currentPage"
          @currentChange="currentChange" />
      </section>
      <section v-show="activeTab === 'Categories'">
        <blog-category-list
          ref="blog-category-list"
          @get-list="handlerGetCategoryList"></blog-category-list>
      </section>
      <!--      <section v-show="activeTab === 'Tags'">-->
      <!--        <blog-tags-list ref="blog-tags-list"></blog-tags-list>-->
      <!--      </section>-->
    </div>


  </section>
</template>
<script>
import {getNewsArticlesList} from '@/api/news'
import MixinOptions from '@/mixins/options'
import BlogCategoryList from '../blog-category-list'

export default {
  name: 'NewContainer',
  components: {
    // BlogTagsList,
    BlogCategoryList,
  },
  mixins: [MixinOptions],
  data() {
    return {
      pageConfig: {
        //  分頁配置
        currentPage: 1,
        total: 10
      },
      activeTab: 'Posts',
      tabList: [
        {
          name: 'Posts',
          label: 'Posts'
        },
        {
          name: 'Categories',
          label: 'Categories'
        },
        // {
        //   name: 'Tags',
        //   label: 'Tags'
        // }
      ],
      tableData: [],
      categoriesData: [],
      formData: {
        name_en_us: '',
        name_zh_hk: ''
      },
      postForm: {
        category_id: 0,
        status: -1,
        newest: 1
      },
      articlesData: [],
    }
  },
  computed: {
    categoryList() {
      const list = this.categoriesData.reduce((result, item) => {
        result.push({
          id: item.category_id,
          name: item.name
        })
        return result
      }, [])
      return [
        {
          id: 0,
          name: 'All Categories'
        },
        ...list
      ]
    },
    statusList() {
      // 0-draft 1-publish 2-schedule 3-unpublish,-1-all
      return [
        {
          id: 0,
          name: 'Draft'
        },
        {
          id: 1,
          name: 'Published'
        },
        {
          id: 2,
          name: 'Scheduled'
        },
        // {
        //   id: 3,
        //   name: 'Unpublished'
        // },
        {
          id: -1,
          name: 'All Posts'
        }
      ]
    },
    newestList() {
      return [
        {
          id: 1,
          name: 'Newest First'
        },
        {
          id: 0,
          name: 'Nomal'
        }
      ]
    }
  },
  watch: {
    property: {
      immediate: true,
      handler() {
        this.network().getNewsArticlesList()
        // this.network().getNewsCategoriesList()
      }
    }
  },
  methods: {
    routerToArticle({ article_id }) {
      this.$router.push({
        path: '/administration/web/content/detail',
        query: {
          id: article_id
        }
      })
    },
    filterArticles() {
      this.pageConfig.page = 1
      this.network().getNewsArticlesList()
    },
    handlerNewCategory() {
      this.$refs['blog-category-list'].changeDialog()
    },
    handlerNewTag() {
      this.$refs['blog-tags-list'].changeDialog()
    },
    routerToPostDetail() {
      this.$router.push({
        path: '/administration/web/content/detail'
      })
    },
    currentChange(page) {
      this.pageConfig.currentPage = page
      this.network().getNewsArticlesList()
    },
    handlerGetCategoryList(list) {
      this.categoriesData = list
    },
    network() {
      return {
        getNewsArticlesList: async () => {
          let { data } = await getNewsArticlesList({
            ...this.postForm,
            page: this.pageConfig.currentPage
          })
          const resultData = data.data.reduce((result, item) => {
            let titleData = {
              'en-US': '',
              'zh-HK': ''
            }
            item.data.some(article => {
              const { language, title } = article
              titleData[language] = title
            })
            result.push({
              ...item,
              titleData
            })
            return result
          }, [])
          this.articlesData = resultData
          this.pageConfig.total = data.meta.total
        },
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.news-container {
  .header{
    position: relative;
    .btn{
      position: absolute;
      right: 0;
      top: 0;
    }
  }
    .content-container {
        position: relative;
        .el-table {
          padding-top: 15px;
        }
        .btn-list {
          span {
            display: inline-block;
            margin-right: 20px;
          }
        }
        .filter-container {
          display: flex;
          justify-content: space-between;
          align-items: center;
          .filter-list {
            display: flex;
            .el-select {
              margin-right: 15px;
              width: 130px;
            }
          }
        }
      }
      .dialog-container {
    padding: 15px;
  }
  .ic-order {
      .svg-inline--fa {
          color: #91939A;
      font-size: 12px;
      }

  }
}
</style>
